import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { VendorApi } from '@mesa-labs/mesa-api/dist/apis/vendor';
import { InvoiceApi } from '@mesa-labs/mesa-api/dist/apis/invoice';
import { types as api } from '@mesa-labs/mesa-api';

import { prepareHeaders, useApi } from './api';

export type EmailTemplateService = 'vendor-service' | 'invoice-service';

const clientFor = (service: EmailTemplateService) => (service === 'vendor-service'
  ? useApi((options) => new VendorApi(CONFIG.api.vendorUrl, options))
  : useApi((options) => new InvoiceApi(CONFIG.api.invoiceUrl, options)));

export const emailTemplatesApi = createApi({
  reducerPath: 'emailTemplatesApi',
  baseQuery: fetchBaseQuery({
    baseUrl: CONFIG.api.vendorUrl,
    prepareHeaders: async (headers) => await prepareHeaders(headers),
  }),
  endpoints: (build) => ({
    getEmailTemplateNames: build.query<api.GetEmailTemplateNamesResponse, { service: EmailTemplateService }>({
      async queryFn({ service }) {
        const data = await clientFor(service).getEmailTemplateNames();
        return { data };
      },
    }),

    getEmailTemplatePreview: build.query<api.PreviewEmailTemplateResponse, { service: EmailTemplateService; templateName: string }>({
      async queryFn({ service, templateName }) {
        const data = await clientFor(service).getEmailTemplatePreview(templateName);
        return { data };
      },
    }),

    sendTestEmailTemplate: build.mutation<
      api.SendTestEmailTemplateResponse,
      { service: EmailTemplateService; templateName: string; request: api.SendTestEmailTemplateRequest }
    >({
      async queryFn({ service, templateName, request }) {
        const data = await clientFor(service).postEmailTemplateTestSend(templateName, request);
        return { data };
      },
    }),
  }),
});

export const {
  useGetEmailTemplateNamesQuery,
  useGetEmailTemplatePreviewQuery,
  useSendTestEmailTemplateMutation,
} = emailTemplatesApi;
